import {
  Box,
  Button,
  Divider,
  ImageListItem,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUploadedDocumentsRequest } from "../../redux/myDocuments/action";
import storePersist, { localConstant } from "../../services/localStorage";
import CustomLoader from "../../components/CustomLoader";
import { useNavigate } from "react-router-dom";
import addVehiclePlaceHolder from "../../assets/svg/addvehicle_placeholder.svg";
import CustomDialog from "../../components/CustomDialog";
import UploadDocuments from "../uploadDocuments";
import { useTranslation } from "react-i18next";
import { getAdobeDocument } from "../../redux/storageDocument/action";
import MenuBar from "../menuBar";
import NavBar from "../../NavBar";
import pdfIcon from "../../assets/images/pdf.png";
import { useResponsive } from "../../hooks/useResponsive";
import moment from "moment";
import { MOMENT_CONSTANTS } from "../../utils/momentUtils";
import PdfDocumentWithZoom from "./pdfWithZoom";
import BottomNav from "../../components/BottomNav/BottomNav";

const MyDocuments = () => {
  const lgUp = useResponsive("up", "lg");
  const smDown = useResponsive("down", "sm");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { documentList, isLoading } = useSelector(
    (state) => state.myDocumentsReducer,
  );
  const [updatedDocumentList, setUpdatedDocumentList] = useState([]);
  const [eSignDocument, setESignDocument] = useState({});
  const [openDocPreview, setOpenDocPreview] = useState(false);
  const [docObj, setDocObj] = useState({ url: "", index: 0 });
  const [isDialogOpen, setDialogOpen] = useState(false);
  const userId = storePersist.get(localConstant.USER_ID);
  const userProfile = storePersist.get(localConstant.USER_PROFILE);

  useEffect(() => {
    if (
      storePersist.get(localConstant.USER_PROFILE) === "OWNER" &&
      (storePersist.get(localConstant.AGREEMENT_STATUS) === "COMPLETED" ||
        storePersist.get(localConstant.AGREEMENT_STATUS) === "COMPLTD")
    )
      dispatch(
        getAdobeDocument(
          storePersist.get(localConstant.AGREEMENT_ID),
          (response) => {
            if (
              response?.response?.agreementStatus === "COMPLETED" ||
              response?.response?.participant?.[0]?.signStatus === "SIGNED"
            ) {
              setESignDocument({
                entityId: null,
                entityType: "OWNER",
                mediaCode: "ESIGN",
                mediaId: Math.random(),
                mediaType: "PDF",
                mediaUpdDate: new Date().toISOString(),
                tempUrl: response?.response?.signedAgreementUrl,
                tempThumUrl: pdfIcon,
              });
            }
          },
        ),
      );
    dispatch(fetchUploadedDocumentsRequest(userId, userProfile, () => {}));
  }, []);

  useEffect(() => {
    if (!eSignDocument?.tempUrl) setUpdatedDocumentList([...documentList]);
    else setUpdatedDocumentList([eSignDocument, ...documentList]);
  }, [documentList, eSignDocument]);

  const getDocumentType = (mediaCode) => {
    switch (mediaCode) {
      case "PROOFINS":
        return t("pages.myDocuments.text05");

      case "DRIVLIC":
        return t("pages.myDocuments.text03");

      case "ESIGN":
        return t("pages.myDocuments.text07");
      case "CMPLOGO":
        return t("pages.myDocuments.text08");

      default:
        break;
    }
  };
  const handleDocumentClick = (item, index) => {
    setOpenDocPreview(true);

    console.log({ item });
    setDocObj({ url: item.tempUrl, item, index });
  };
  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <NavBar title={t("pages.myDocuments.pageHeading")} enableBack={false} />
      <MenuBar activeTab={5} />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {updatedDocumentList?.length > 0 && (
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
              margin: 10,
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Segoe UI",
                fontSize: 16,
                fontWeight: 700,
                textAlign: "right",
                color: "#1D5AB9",
                top: 98,
                marginLeft: 2,
              }}
              variant="buttonText"
            />

            <Button
              onClick={() => {
                if (smDown) {
                  navigate("/uploadDocuments");
                  return;
                }
                setDialogOpen(true);
              }}
              variant="contained"
              alignSelf={"center"}
              style={{
                width: 98,
                height: 32,
                marginLeft: 88,
                alignItems: "center",
                display: "flex",
              }}
            >
              <Typography variant="buttonText" color="common.buttonText">
                + {t("commonLabels.text04")}
              </Typography>
            </Button>
          </div>
        )}

        {updatedDocumentList?.length > 0 ? (
          updatedDocumentList.map((d, dIndex) => {
            return (
              <div
                key={d?.mediaId}
                style={{ alignItems: "center", flexDirection: "row" }}
              >
                <div
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <ListItem
                    onClick={(item, index) => handleDocumentClick(d, dIndex)}
                    alignItems="center"
                  >
                    {d.mediaType === "PDF" ? (
                      <div
                        style={{
                          width: 60,
                          height: 60,
                          // top: 12,
                          borderRadius: 8,
                          objectFit: "contain",
                        }}
                      >
                        <ImageListItem>
                          <img
                            alt=""
                            style={{
                              width: 60,
                              height: 60,
                              top: 12,
                              borderRadius: 8,
                            }}
                            loading="lazy"
                            src={d?.tempThumUrl}
                          />
                        </ImageListItem>
                      </div>
                    ) : (
                      <ImageListItem>
                        <img
                          alt=""
                          style={{
                            width: 60,
                            height: 60,
                            top: 12,
                            borderRadius: 8,
                          }}
                          loading="lazy"
                          src={d?.tempThumUrl}
                        />
                      </ImageListItem>
                    )}

                    <ListItemText
                      primary={
                        <div
                          style={{
                            flexDirection: "row",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            color="text.primary"
                            style={{
                              fontFamily: "Segoe UI",
                              fontSize: 16,
                              fontWeight: 600,
                              textAlign: "left",
                              letterSpacing: "0.5%",
                            }}
                          >
                            {getDocumentType(d?.mediaCode)}
                          </Typography>
                        </div>
                      }
                      style={{
                        fontFamily: "Segoe UI",
                        fontSize: 16,
                        fontWeight: 600,
                        textAlign: "left",
                        letterSpacing: "0.5%",
                      }}
                      sx={{ marginLeft: 2 }}
                      secondary={
                        <React.Fragment>
                          <Typography
                            sx={{ display: "inline" }}
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            {t("pages.myDocuments.text06")}{" "}
                            {moment(d?.mediaUpdDate).format(
                              MOMENT_CONSTANTS.date.monthDayYear,
                            )}
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                </div>
                <Divider
                  variant="fullWidth"
                  color="lightGray"
                  style={{ width: "100%" }}
                />
              </div>
            );
          })
        ) : (
          <>
            <img
              src={addVehiclePlaceHolder}
              hidden={updatedDocumentList.length}
              style={{
                width: 317,
                height: 240,
                marginTop: 200,
                alignSelf: "center",
              }}
              alt=""
            />
            {updatedDocumentList.length === 0 && (
              <Button
                onClick={() => {
                  if (smDown) {
                    navigate("/uploadDocuments");
                    return;
                  }
                  setDialogOpen(true);
                }}
                variant="contained"
                style={{
                  alignSelf: "center",
                  width: 199,
                  height: 32,
                  margin: "auto",
                  marginTop: "10%",
                  marginBottom: "20%",
                  display: "flex",
                }}
              >
                <Typography variant="buttonText" color="common.buttonText">
                  + {t("pages.myDocuments.text01")}
                </Typography>
              </Button>
            )}
          </>
        )}
      </Box>
      {isLoading && <CustomLoader />}

      <CustomDialog
        isOpen={isDialogOpen}
        title="Upload Documents"
        Content={UploadDocuments}
        reset={() => setDialogOpen(false)}
      />

      <CustomDialog
        isOpen={openDocPreview}
        title={getDocumentType(docObj?.item?.mediaCode) || "Document"}
        Content={() => (
          <Box
            key={docObj?.item?.mediaId}
            spacing={1}
            width={1}
            height="60vh"
            sx={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            {docObj?.item?.mediaType === "PDF" ? (
              <PdfDocumentWithZoom url={docObj?.url} />
            ) : (
              <img
                style={{
                  objectFit: "contain",
                  height: "100%",
                  maxWidth: "95%",
                  maxHeight: "90%",
                }}
                loading="eager"
                src={docObj?.url}
                alt=""
              />
            )}
          </Box>
        )}
        reset={() => setOpenDocPreview(false)}
      />
      <BottomNav activeTab={5} />
    </div>
  );
};

export default MyDocuments;
